module.exports = __webpack_public_path__ + "img/P150T_weapon_59.33661cb2.png";